// @ai-generated 2026-10-08T09:40:29+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
import { useTableMode } from '@Hooks/useTableModes';
import { containerStockTableModes, type ContainerStockTableModes } from './containerStockTableModes';
import { FrameListPlannedContainerActions } from './FrameListPlannedContainerActions';
import { FrameListStandingContainerStock } from './FrameListStandingContainerStock';

/** The container stock and the container actions that are planned for it, one table mode each. */
export function FrameListContainerStock() {
    const tableModeProps = useTableMode<ContainerStockTableModes>('stock', containerStockTableModes);

    return tableModeProps.tableModeValue === 'planned' ? (
        <FrameListPlannedContainerActions {...tableModeProps} />
    ) : (
        <FrameListStandingContainerStock {...tableModeProps} />
    );
}
